import { AxiosResponse } from 'axios';

import { HttpClient } from 'api/HttpClient';
import { Address } from 'api/ApplicationApi';

export interface BorrowerDto {
  id: string;
  locked: boolean;
  lockReason: BorrowerLockReason | null;
  variables: BorrowerVariablesDto;
}

export enum BorrowerLockReason {
  Fraud = 'FRAUD',
  BankFraud = 'Bank Fraud',
}

interface BorrowerVariablesDto {
  borrower_first_name: string;
  borrower_last_name: string;
  borrower_personal_id_number: string;
  borrower_date_of_birth: string;
  borrower_email: string;
  borrower_phone: string;
  borrower_home_address: Address;
  borrower_is_permanent_resident: boolean;
  borrower_fraud: boolean | null;
  borrower_county: string | null;
}

export interface BorrowerAddress {
  streetName: string;
  streetNumber: string;
  city: string;
  stateOrProvince: string;
  zipOrPostalCode: string;
  county?: string | null;
}

export interface CreateBorrowerDto {
  firstName: string;
  lastName: string;
  personalIdNumber: string;
  dateOfBirth: string;
  email: string;
  phone: string;
  address: BorrowerAddress;
}

export interface UpdateBorrowerDto {
  firstName?: string;
  lastName?: string;
  dateOfBirth?: string;
  email?: string;
  phone?: string;
  address?: BorrowerAddress;
}

export default class BorrowerApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/borrowers' || '');
  }

  public async getBorrowerByToken() {
    return this.instance.get('').then((response: AxiosResponse<BorrowerDto>) => response.data);
  }

  public async updateBorrower(updateBorrowerDto: UpdateBorrowerDto): Promise<BorrowerDto> {
    return this.instance.put('', updateBorrowerDto).then((response: AxiosResponse<BorrowerDto>) => response.data);
  }
}

export const borrowerApi = new BorrowerApi();
